(() => {
  const SITE_ID = 101221361;
  const STORAGE_KEY = 'tjh_lead_cid';
  const MAX_AGE = 30 * 60 * 1000;
  const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  const CONFIRMATION_PATH = /^\/(thank-you(-[0-9]+)?|thank-you-confirmation|es\/gracias)\/?$/;

  const accutrakLead = {
    sent: new Set(),
    pending: new Set(),
    confirmationCid: null,
    lastStatus: 'idle',

    init() {
      const custom = window.Accutrak_custom = window.Accutrak_custom || {};

      // A submission ID must not be restored from an older Accutrak visitor cookie.
      custom.visitor_keys_cookie = (custom.visitor_keys_cookie || ['campaign'])
        .filter((key) => key !== 'leadid');

      if (CONFIRMATION_PATH.test(window.location.pathname)) {
        // Native/fallback form submissions do not run the AJAX storage callback.
        // The server carries the same posted UUID in its successful redirect.
        const urlCid = this.readUrl();
        const cid = urlCid === undefined ? this.readStored() : urlCid;

        if (urlCid === null) {
          // An explicit empty/invalid handoff must not reuse a previous lead's ID.
          try {
            sessionStorage.removeItem(STORAGE_KEY);
          } catch (e) {}
        }

        if (cid) {
          this.confirmationCid = cid;
          this.setLead(cid);
          this.lastStatus = urlCid ? 'confirmation_url' : 'confirmation_storage';

          if (urlCid) {
            // Keep the existing GA4 stored-ID variable working during the cutover.
            // Only a URL handoff refreshes storage; reading storage must not extend its TTL.
            try {
              sessionStorage.setItem(STORAGE_KEY, JSON.stringify({cid, ts: Date.now()}));
            } catch (e) {}
          }
        } else {
          this.lastStatus = 'missing_confirmation_cid';
        }
      }
    },

    valid(cid) {
      return typeof cid === 'string' && UUID_PATTERN.test(cid);
    },

    readUrl() {
      try {
        const params = new URLSearchParams(window.location.search);

        if (!params.has('lead_cid')) {
          return undefined;
        }

        const cid = params.get('lead_cid');

        if (this.valid(cid)) {
          return cid.toLowerCase();
        }

        return null;
      } catch (e) {}

      return undefined;
    },

    readStored() {
      try {
        const stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
        const age = Date.now() - stored?.ts;

        if (this.valid(stored?.cid) && Number.isFinite(stored.ts) && age >= 0 && age < MAX_AGE) {
          return stored.cid;
        }
      } catch (e) {}

      return null;
    },

    setLead(cid) {
      if (!this.valid(cid)) {
        return false;
      }

      const custom = window.Accutrak_custom = window.Accutrak_custom || {};
      custom.visitor = custom.visitor || {};
      custom.visitor.leadid = cid;

      return true;
    },

    // Called only by the consent-controlled GTM inline conversion tag.
    // Do not load Accutrak here: its existing loader remains responsible for consent.
    trackInline(cid) {
      if (!this.valid(cid)) {
        this.lastStatus = 'invalid_cid';
        return;
      }

      if (this.sent.has(cid) || this.pending.has(cid)) {
        return;
      }

      this.pending.add(cid);
      this.lastStatus = 'waiting_for_tracker';
      const deadline = Date.now() + 10 * 1000;

      const send = () => {
        try {
          const tracker = window.Accutrak;

          // Wait for the site's initial pageview, not just the async script's load.
          // Otherwise its delayed setup could send the same lead twice.
          if (typeof tracker?.pageview === 'function'
            && typeof tracker.site_id_exists === 'function'
            && typeof tracker.is_pageview_fired === 'function'
            && tracker.site_id_exists(SITE_ID)
            && tracker.is_pageview_fired(SITE_ID)) {
            this.setLead(cid);
            tracker.pageview();
            this.sent.add(cid);
            this.pending.delete(cid);
            // This means request creation, not confirmation of vendor ingestion.
            this.lastStatus = 'request_queued';
            return;
          }
        } catch (e) {
          this.pending.delete(cid);
          this.lastStatus = 'tracker_error';
          return;
        }

        if (Date.now() < deadline) {
          setTimeout(send, 100);
        } else {
          this.pending.delete(cid);
          this.lastStatus = 'tracker_timeout';
        }
      };

      send();
    }
  };

  window.tjhAccutrakLead = accutrakLead;
  accutrakLead.init();
})();
